import { SetupState, setupStateValues } from "./flow/types.js"

export const setupStateSequence: SetupState[] = [...setupStateValues]

export function getNextSetupState(current: SetupState): SetupState {
  const currentIndex = setupStateSequence.indexOf(current)
  if (currentIndex === -1) {
    throw new Error(`Unknown setup state: ${current}`)
  }

  if (currentIndex === setupStateSequence.length - 1) {
    return "DONE"
  }

  return setupStateSequence[currentIndex + 1]
}

export function getPreviousSetupState(current: SetupState): SetupState {
  const currentIndex = setupStateSequence.indexOf(current)
  if (currentIndex === -1) {
    throw new Error(`Unknown setup state: ${current}`)
  }

  if (currentIndex === 0) {
    return "INIT"
  }

  return setupStateSequence[currentIndex - 1]
}

export function isValidSetupStateTransition(from: SetupState, to: SetupState): boolean {
  if (from === to) return true

  return getNextSetupState(from) === to
}
